var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({staticClass:"elevation-3",attrs:{"fab":"","small":"","color":"primary"},on:{"click":function (evt) { return _vm.$emit('click', evt); }}},_vm.on),[_vm._t("default",function(){return [_c('app-icon',[_vm._v("add")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }